module.exports = __webpack_public_path__ + "media/images/user-profile-default-4bcb9f8e.png";